import React, {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import dayjs from "dayjs";
import Icon from "../../components/Icon/Icon";
import Portal from "../../components/Portal/Portal";
import { IconColorE, LangE } from "../../models/enums";
import { useLazyGetProjectByIdQuery } from "../../api/projectsApi";
import { toast } from "react-toastify";
import { useTranslate } from "../../utils/hooks/useTranslate";
import { TOAST_DURATION } from "../../utils/helpers/constants";

import { isMobileOrTablet } from "../../utils/helpers/mediaQueries";
import styles from "./styles.module.scss";
import { useAppSelector } from "../../store/hooks";
import { selectCurrentLang } from "../../store/selectors/appSelectors";
import { selectCurrentUser } from "../../store/selectors/authSelectors";
import { useGetUserInfoQuery } from "../../api/clientAPI";
import Loader from "../../components/Loader/Loader";

type JumboFormRawMaterialPropTypes = {
  onClose: Dispatch<SetStateAction<boolean>>;
  campaignNumber: number;
  deliveryNumber: number;
  campaignName: string;
  deliveryName: string;
  projectId: number;
  broadcastingDate: string;
  postProductionCompanyName: string;
  JumboForm_EN: string;
  JumboForm_HE: string;
};

const WIDTH = isMobileOrTablet() ? window.innerWidth * 0.9 : 460;
const HEIGHT = isMobileOrTablet() ? window.innerHeight * 0.8 : 816;

const JumboFormRawMaterial: FC<JumboFormRawMaterialPropTypes> = (props) => {
  const {
    onClose,
    campaignName,
    campaignNumber,
    deliveryNumber,
    projectId,
    postProductionCompanyName,
    JumboForm_EN,
    JumboForm_HE,
  } = props;
  const lang = useAppSelector(selectCurrentLang);
  const [iframeOnloadEventCounter, setIframeOnloadEventCounter] = useState(0);
  const [refetchDeliveryData] = useLazyGetProjectByIdQuery();
  const { data, isFetching } = useGetUserInfoQuery({});
  const { t } = useTranslate();
  const src = `${process.env.REACT_APP_JUMBOMAIL_URL}/form?foid=${
    lang === LangE.EN ? JumboForm_EN : JumboForm_HE
  }&tid=${projectId}&field0=${campaignNumber}&field1=${campaignName}&field2=${deliveryNumber}&field3=${postProductionCompanyName}&field4=${
    data?.ClientInfo?.ContactName || ""
  }&field5=${data?.ClientInfo?.Email || ""}&field6=${data?.ClientInfo?.Phone || ""}`;

  useEffect(() => {
    if (iframeOnloadEventCounter === 2) {
      refetchDeliveryData({
        id: projectId,
        detailed: true,
      }).then(() => {
        // toast.success(t`Raw materials added`, {
        //   autoClose: TOAST_DURATION,
        // });
        // onClose(false);
      });
    }
  }, [iframeOnloadEventCounter]);

  const handleClose = () => {
    onClose(false);
  };

  const handleLoad = () => {
    setIframeOnloadEventCounter((prev) => prev + 1);
  };

  return (
    <Portal id="root">
      <div className={styles.overlay}>
        <div className={styles.modal}>
          <Icon
            name="close"
            className={styles.closeIcon}
            color={IconColorE.WHITE}
            onClick={handleClose}
          />
          <div style={{ width: WIDTH, height: HEIGHT }}>
            {isFetching ? (
              <Loader />
            ) : (
              <>
                {iframeOnloadEventCounter !== 2 && (
                  <iframe
                    className={styles.iframe}
                    src={src}
                    width={WIDTH}
                    height={HEIGHT}
                    onLoad={handleLoad}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default JumboFormRawMaterial;
